import React from 'react';
import dayJS from 'dayjs';
import { FormattedMessage, defineMessages } from 'react-intl';

import isDateInFuture from '../functions/isDateInFuture';


// TODO: Should rewrite to <FormattedMessage>?
const MESSAGES = defineMessages({
    existingMortgage: {
        id: 'mtg-wizard.validators.amortization.existing-mortgage',
        defaultMessage: 'Remaining amortization must be between 1 and 30 years',
    },
    greaterThanZero: {
        id: 'mtg-wizard.validators.amount.greater-than-zero',
        defaultMessage: 'Please enter a valid amount ($0 or more)',
    },
    atLeastOne: {
        id: 'mtg-wizard.validators.amount.at-least-one',
        defaultMessage: 'Please enter a valid amount ($1 or more)',
    },
    closingInFuture: {
        id: 'mtg-wizard.validators.closing-date.in-future',
        defaultMessage: 'Closing date must be in the future',
    },
    refinanceInFuture: {
        id: 'mtg-wizard.validators.refinance-date.in-future',
        defaultMessage: 'Refinance date must be in the future',
    },
    renewalInFuture: {
        id: 'mtg-wizard.validators.renewal-date.in-future',
        defaultMessage: 'Renewal date must be in the future',
    },
    requiredInFuture: {
        id: 'mtg-wizard.validators.funds-required-date.in-future',
        defaultMessage: 'Renewal date must be in the future',
    },
});


/**
 * Mortgage wizard contains a lot of the same down payment validators
 * Should eventually be combined into mtg-common
 */

/**
 * Many number fields are stored as 32-bit integers.
 * It is very unlikely that a user will enter a number higher than 1 billion, so we'll just tell them to keep it a certain length for simplicity.
 */
const INT_32_MAXIMUM = Math.pow(2, 31);
const INT_32_VALIDATOR = {
    fn: (value) => value <= INT_32_MAXIMUM,
    message: (
        <FormattedMessage
            id="mtg-common.Validators.int32"
            defaultMessage="Character limit exceeded. Must be within 9 characters."
        />
    ),
};

function isAmortizationValid(amortization) {
    return 1 <= amortization && amortization <= 30;
}
const AMORTIZATION_VALIDATOR_EXISTING_MORTGAGE = {
    fn: isAmortizationValid,
    message: MESSAGES.existingMortgage,
};


const GREATER_THAN_OR_EQUAL_TO_ZERO_VALIDATOR = {
    fn: value => value >= 0,
    message: MESSAGES.greaterThanZero,
};

const GREATER_THAN_ZERO_VALIDATOR = {
    fn: value => value > 0,
    message: MESSAGES.atLeastOne,
};

const CLOSING_DATE_IN_FUTURE_VALIDATOR = {
    fn: isDateInFuture,
    message: MESSAGES.closingInFuture,
};
const REFINANCE_DATE_IN_FUTURE_VALIDATOR = {
    fn: isDateInFuture,
    message: MESSAGES.refinanceInFuture,
};
const RENEWAL_DATE_IN_FUTURE_VALIDATOR = {
    fn: isDateInFuture,
    message: MESSAGES.renewalInFuture,
};
const DATE_FUNDS_REQUIRED_IN_FUTURE_VALIDATOR = {
    fn: isDateInFuture,
    message: MESSAGES.requiredInFuture,
};


/* Penalty validators */
const RATE_OVER_20_PERCENT_VALIDATOR = {
    fn: (rate) => rate <= 20,
    message: (
        <FormattedMessage
            id="mtg-common.validators.errorMessage.rateOverTwentyPercent"
            defaultMessage="Please enter a valid rate"
        />
    ),
};

const START_DATE_IN_FUTURE_VALIDATOR = {
    fn: (date) =>
        dayJS(date).isBefore(dayJS())
    ,
    message: (
        <FormattedMessage
            id="mtg-common.validators.errorMessage.startDateInFuture"
            defaultMessage="Start date must not be in the future"
        />
    ),
};

const TERM_ENDED_VALIDATOR = {
    fn: (date, { originalTerm }) =>
        // Has the term already ended?
        dayJS().subtract(originalTerm, 'year').isBefore(dayJS(date))
    ,
    message: (
        <FormattedMessage
            id="mtg-common.validators.errorMessage.termEnded"
            defaultMessage="Please adjust your mortgage term or start date"
        />
    ),
};

// Validator for amortization inputs
function getMaxAmortizationValidator(amortizationPeriod = 30) {
    return ({
        fn: (value) => value <= amortizationPeriod,
        message:(
            <FormattedMessage
                id="mtg-common.validator.maxAmortization"
                defaultMessage="Must not exceed {amortizationPeriod} years"
                values={{
                    amortizationPeriod,
                }}
            />
        ),
    });
}

// Validator for percentage inputs
function getMaxPercentValidator(maxPercent = 100) {
    return ({
        fn: (value) => value <= maxPercent,
        message:(
            <FormattedMessage
                id="Validator.MaxPercentage"
                defaultMessage="Must not exceed {maxPercent}%"
                values={{
                    maxPercent,
                }}
            />
        ),
    });
}

export {
    INT_32_VALIDATOR,
    CLOSING_DATE_IN_FUTURE_VALIDATOR,
    REFINANCE_DATE_IN_FUTURE_VALIDATOR,
    RENEWAL_DATE_IN_FUTURE_VALIDATOR,
    DATE_FUNDS_REQUIRED_IN_FUTURE_VALIDATOR,
    AMORTIZATION_VALIDATOR_EXISTING_MORTGAGE,
    GREATER_THAN_OR_EQUAL_TO_ZERO_VALIDATOR,
    RATE_OVER_20_PERCENT_VALIDATOR,
    START_DATE_IN_FUTURE_VALIDATOR,
    TERM_ENDED_VALIDATOR,
    GREATER_THAN_ZERO_VALIDATOR,
    getMaxAmortizationValidator,
    getMaxPercentValidator,
};
